// Dashboard Module and Features
export const DASHBOARD_MODULE = "DASHBOARD_MODULE";
export const VIEW_BALANCE_AND_ADVANCE_SUMMARY = "DASHBOARD_MODULE.VIEW_BALANCE_AND_ADVANCE_SUMMARY";
export const VIEW_PROJECT_SUMMARY = "DASHBOARD_MODULE.VIEW_PROJECT_SUMMARY";
export const VIEW_EXPENSE_SUMMARY = "DASHBOARD_MODULE.VIEW_EXPENSE_SUMMARY";

// Dashboard Pro Module
export const DASHBOARD_PRO_MODULE = "DASHBOARD_PRO_MODULE";
export const VIEW_PRO_BALANCE_AND_ADVANCE_SUMMARY = "DASHBOARD_PRO_MODULE.VIEW_BALANCE_AND_ADVANCE_SUMMARY";
export const VIEW_PRO_PROJECT_SUMMARY = "DASHBOARD_PRO_MODULE.VIEW_PROJECT_SUMMARY";
export const VIEW_PRO_EXPENSE_SUMMARY = "DASHBOARD_PRO_MODULE.VIEW_EXPENSE_SUMMARY";
export const VIEW_PRO_PNL_SUMMARY = "DASHBOARD_PRO_MODULE.VIEW_PNL_SUMMARY";
export const VIEW_PRO_DAILY_TRANSACTIONS = "DASHBOARD_PRO_MODULE.VIEW_DAILY_TRANSACTIONS";
export const VIEW_PRO_DELAYED_PROJECTS = "DASHBOARD_PRO_MODULE.VIEW_DELAYED_PROJECTS";
export const VIEW_PRO_MONTHLY_INCOME_EXPENSE = "DASHBOARD_PRO_MODULE.VIEW_MONTHLY_INCOME_EXPENSE";
export const VIEW_PRO_TASK_SUMMARY = "DASHBOARD_PRO_MODULE.VIEW_TASK_SUMMARY";

// CRM Module and Features
export const CRM_MODULE = "CRM_MODULE";
export const CRM_VIEW_ALL_LEAD = "CRM_MODULE.VIEW_ALL_LEAD";
export const CRM_VIEW_ASSIGNED_LEAD = "CRM_MODULE.VIEW_ASSIGNED_LEAD";
export const CRM_CREATE_LEAD = "CRM_MODULE.CREATE_LEAD";
export const CRM_EDIT_LEAD = "CRM_MODULE.EDIT_LEAD";
export const CRM_DELETE_LEAD = "CRM_MODULE.DELETE_LEAD";
export const CRM_EXPORT_LEAD = "CRM_MODULE.EXPORT_LEAD";
export const CRM_CREATE_LEAD_STATUS = "CRM_MODULE.CREATE_LEAD_STATUS";
export const CRM_EDIT_LEAD_STATUS = "CRM_MODULE.EDIT_LEAD_STATUS";
export const CRM_DELETE_LEAD_STATUS = "CRM_MODULE.DELETE_LEAD_STATUS";

// Project Module and Features
export const PROJECT_MODULE = "PROJECT_MODULE";
export const VIEW_PROJECT = "PROJECT_MODULE.VIEW_PROJECT";
export const CREATE_PROJECT = "PROJECT_MODULE.CREATE_PROJECT";
export const EDIT_PROJECT = "PROJECT_MODULE.EDIT_PROJECT";
export const DELETE_PROJECT = "PROJECT_MODULE.DELETE_PROJECT";
export const EXPORT_PROJECT = "PROJECT_MODULE.EXPORT_PROJECT";
export const VIEW_STAGE = "PROJECT_MODULE.VIEW_STAGE";
export const CREATE_STAGE = "PROJECT_MODULE.CREATE_STAGE";
export const EDIT_STAGE = "PROJECT_MODULE.EDIT_STAGE";
export const DELETE_STAGE = "PROJECT_MODULE.DELETE_STAGE";

// Client Module and Features
export const CLIENT_MODULE = "CLIENT_MODULE";
export const VIEW_CLIENT = "CLIENT_MODULE.VIEW_CLIENT";
export const CREATE_CLIENT = "CLIENT_MODULE.CREATE_CLIENT";
export const EDIT_CLIENT = "CLIENT_MODULE.EDIT_CLIENT";
export const DELETE_CLIENT = "CLIENT_MODULE.DELETE_CLIENT";
export const EXPORT_CLIENT = "CLIENT_MODULE.EXPORT_CLIENT";
export const ADD_CLIENT_INCOME = "CLIENT_MODULE.ADD_CLIENT_INCOME";
export const EDIT_CLIENT_INCOME = "CLIENT_MODULE.EDIT_CLIENT_INCOME";
export const DELETE_CLIENT_INCOME = "CLIENT_MODULE.DELETE_CLIENT_INCOME";
export const ENABLE_CLIENT_INCOME_BACKDATE_ENTRY = "CLIENT_MODULE.ENABLE_CLIENT_INCOME_BACKDATE_ENTRY";
export const ADD_CLIENT_PAYMENT = "CLIENT_MODULE.ADD_CLIENT_PAYMENT";
export const EDIT_CLIENT_PAYMENT = "CLIENT_MODULE.EDIT_CLIENT_PAYMENT";
export const DELETE_CLIENT_PAYMENT = "CLIENT_MODULE.DELETE_CLIENT_PAYMENT";
export const ENABLE_CLIENT_PAYMENT_BACKDATE_ENTRY = "CLIENT_MODULE.ENABLE_CLIENT_PAYMENT_BACKDATE_ENTRY";
export const VIEW_CLIENT_ANALYTICS = "CLIENT_MODULE.VIEW_CLIENT_ANALYTICS";
export const VIEW_CLIENT_STATEMENT = "CLIENT_MODULE.VIEW_CLIENT_STATEMENT";
export const EXPORT_CLIENT_STATEMENT = "CLIENT_MODULE.EXPORT_CLIENT_STATEMENT";
export const VIEW_CLIENT_LEDGER_MODE_STATEMENT = "CLIENT_MODULE.VIEW_CLIENT_LEDGER_MODE_STATEMENT";

// Employee Module and Features
export const EMPLOYEE_MODULE = "EMPLOYEE_MODULE";
export const VIEW_EMPLOYEE = "EMPLOYEE_MODULE.VIEW_EMPLOYEE";
export const CREATE_EMPLOYEE = "EMPLOYEE_MODULE.CREATE_EMPLOYEE";
export const EDIT_EMPLOYEE = "EMPLOYEE_MODULE.EDIT_EMPLOYEE";
export const DELETE_EMPLOYEE = "EMPLOYEE_MODULE.DELETE_EMPLOYEE";
export const EXPORT_EMPLOYEE = "EMPLOYEE_MODULE.EXPORT_EMPLOYEE";
export const ADD_EMPLOYEE_ATTENDANCE = "EMPLOYEE_MODULE.ADD_EMPLOYEE_ATTENDANCE";
export const EDIT_EMPLOYEE_ATTENDANCE = "EMPLOYEE_MODULE.EDIT_EMPLOYEE_ATTENDANCE";
export const DELETE_EMPLOYEE_ATTENDANCE = "EMPLOYEE_MODULE.DELETE_EMPLOYEE_ATTENDANCE";
export const ADD_EMPLOYEE_SALARY = "EMPLOYEE_MODULE.ADD_EMPLOYEE_SALARY";
export const EDIT_EMPLOYEE_SALARY = "EMPLOYEE_MODULE.EDIT_EMPLOYEE_SALARY";
export const DELETE_EMPLOYEE_SALARY = "EMPLOYEE_MODULE.DELETE_EMPLOYEE_SALARY";
export const ENABLE_EMPLOYEE_SALARY_BACKDATE_ENTRY = "EMPLOYEE_MODULE.ENABLE_EMPLOYEE_SALARY_BACKDATE_ENTRY";
export const ADD_EMPLOYEE_INCENTIVE = "EMPLOYEE_MODULE.ADD_EMPLOYEE_INCENTIVE";
export const EDIT_EMPLOYEE_INCENTIVE = "EMPLOYEE_MODULE.EDIT_EMPLOYEE_INCENTIVE";
export const DELETE_EMPLOYEE_INCENTIVE = "EMPLOYEE_MODULE.DELETE_EMPLOYEE_INCENTIVE";
export const VIEW_EMPLOYEE_ANALYTICS = "EMPLOYEE_MODULE.VIEW_EMPLOYEE_ANALYTICS";
export const VIEW_EMPLOYEE_STATEMENT = "EMPLOYEE_MODULE.VIEW_EMPLOYEE_STATEMENT";
export const EXPORT_EMPLOYEE_STATEMENT = "EMPLOYEE_MODULE.EXPORT_EMPLOYEE_STATEMENT";

// Worker Module and Features
export const WORKER_MODULE = "WORKER_MODULE";
export const VIEW_WORKER = "WORKER_MODULE.VIEW_WORKER";
export const CREATE_WORKER = "WORKER_MODULE.CREATE_WORKER";
export const EDIT_WORKER = "WORKER_MODULE.EDIT_WORKER";
export const DELETE_WORKER = "WORKER_MODULE.DELETE_WORKER";
export const EXPORT_WORKER = "WORKER_MODULE.EXPORT_WORKER";
export const ADD_WORK = "WORKER_MODULE.ADD_WORK";
export const EDIT_WORK = "WORKER_MODULE.EDIT_WORK";
export const DELETE_WORK = "WORKER_MODULE.DELETE_WORK";
export const ENABLE_WORK_BACKDATE_ENTRY = "WORKER_MODULE.ENABLE_WORK_BACKDATE_ENTRY";
export const ADD_WORKER_PAYMENT = "WORKER_MODULE.ADD_WORKER_PAYMENT";
export const EDIT_WORKER_PAYMENT = "WORKER_MODULE.EDIT_WORKER_PAYMENT";
export const DELETE_WORKER_PAYMENT = "WORKER_MODULE.DELETE_WORKER_PAYMENT";
export const ENABLE_WORKER_PAYMENT_BACKDATE_ENTRY = "WORKER_MODULE.ENABLE_WORKER_PAYMENT_BACKDATE_ENTRY";
export const VIEW_GROUP_WORK = "WORKER_MODULE.VIEW_GROUP_WORK";
export const ADD_GROUP_WORK = "WORKER_MODULE.ADD_GROUP_WORK";
export const EDIT_GROUP_WORK = "WORKER_MODULE.EDIT_GROUP_WORK";
export const DELETE_GROUP_WORK = "WORKER_MODULE.DELETE_GROUP_WORK";
export const VIEW_WORKER_ANALYTICS = "WORKER_MODULE.VIEW_WORKER_ANALYTICS";
export const VIEW_WORKER_STATEMENT = "WORKER_MODULE.VIEW_WORKER_STATEMENT";
export const VIEW_WORKER_LEDGER_MODE_STATEMENT = "WORKER_MODULE.VIEW_WORKER_LEDGER_MODE_STATEMENT";
export const EXPORT_WORKER_STATEMENT = "WORKER_MODULE.EXPORT_WORKER_STATEMENT";
export const ENABLE_WORKER_ADVANCE_PAYMENT = "WORKER_MODULE.ENABLE_WORKER_ADVANCE_PAYMENT";
export const ADD_BULK_WORK = "WORKER_MODULE.ADD_BULK_WORK";
export const EDIT_BULK_WORK = "WORKER_MODULE.EDIT_BULK_WORK";
export const ADD_BULK_WORKER_PAYMENT = "WORKER_MODULE.ADD_BULK_WORKER_PAYMENT";
export const EDIT_BULK_WORKER_PAYMENT = "WORKER_MODULE.EDIT_BULK_WORKER_PAYMENT";

// Weekly Worker Payment Module and Features — a separate, independently-licensable module from
// WORKER_MODULE (same relationship as CRM_MODULE -> CRM_PRO_MODULE): bulk weekly payments, the
// per-project report/pay/supervisor flow, and worker welfare.
export const WEEKLY_WORKER_PAYMENT_MODULE = "WEEKLY_WORKER_PAYMENT_MODULE";
export const VIEW_WEEKLY_WORKER_PAYMENT = "WEEKLY_WORKER_PAYMENT_MODULE.VIEW_WEEKLY_WORKER_PAYMENT";
export const ADD_WEEKLY_WORKER_PAYMENT = "WEEKLY_WORKER_PAYMENT_MODULE.ADD_WEEKLY_WORKER_PAYMENT";
export const EDIT_WEEKLY_WORKER_PAYMENT = "WEEKLY_WORKER_PAYMENT_MODULE.EDIT_WEEKLY_WORKER_PAYMENT";
export const DELETE_WEEKLY_WORKER_PAYMENT = "WEEKLY_WORKER_PAYMENT_MODULE.DELETE_WEEKLY_WORKER_PAYMENT";
export const VIEW_WEEKLY_WORKER_PAYMENT_REPORT = "WEEKLY_WORKER_PAYMENT_MODULE.VIEW_WEEKLY_WORKER_PAYMENT_REPORT";
export const PAY_WEEKLY_WORKER_PAYMENT = "WEEKLY_WORKER_PAYMENT_MODULE.PAY_WEEKLY_WORKER_PAYMENT";
export const ASSIGN_WEEKLY_WORKER_PAYMENT_SUPERVISOR = "WEEKLY_WORKER_PAYMENT_MODULE.ASSIGN_WEEKLY_WORKER_PAYMENT_SUPERVISOR";
export const EXPORT_WEEKLY_WORKER_PAYMENT = "WEEKLY_WORKER_PAYMENT_MODULE.EXPORT_WEEKLY_WORKER_PAYMENT";
export const VIEW_WORKER_WELFARE = "WEEKLY_WORKER_PAYMENT_MODULE.VIEW_WORKER_WELFARE";
// Forward-looking only — no UI uses these yet (see hr.permissions.ts on the backend).
export const CREATE_WORKER_WELFARE = "WEEKLY_WORKER_PAYMENT_MODULE.CREATE_WORKER_WELFARE";
export const EDIT_WORKER_WELFARE = "WEEKLY_WORKER_PAYMENT_MODULE.EDIT_WORKER_WELFARE";
export const PAY_WORKER_WELFARE = "WEEKLY_WORKER_PAYMENT_MODULE.PAY_WORKER_WELFARE";

// Subcontractor Module and Features
export const SUBCONTRACTOR_MODULE = "SUBCONTRACTOR_MODULE";
export const VIEW_SUBCONTRACTOR = "SUBCONTRACTOR_MODULE.VIEW_SUBCONTRACTOR";
export const CREATE_SUBCONTRACTOR = "SUBCONTRACTOR_MODULE.CREATE_SUBCONTRACTOR";
export const EDIT_SUBCONTRACTOR = "SUBCONTRACTOR_MODULE.EDIT_SUBCONTRACTOR";
export const DELETE_SUBCONTRACTOR = "SUBCONTRACTOR_MODULE.DELETE_SUBCONTRACTOR";
export const EXPORT_SUBCONTRACTOR = "SUBCONTRACTOR_MODULE.EXPORT_SUBCONTRACTOR";
export const VIEW_CONTRACT = "SUBCONTRACTOR_MODULE.VIEW_CONTRACT";
export const CREATE_CONTRACT = "SUBCONTRACTOR_MODULE.CREATE_CONTRACT";
export const EDIT_CONTRACT = "SUBCONTRACTOR_MODULE.EDIT_CONTRACT";
export const DELETE_CONTRACT = "SUBCONTRACTOR_MODULE.DELETE_CONTRACT";
export const EXPORT_CONTRACT = "SUBCONTRACTOR_MODULE.EXPORT_CONTRACT";
export const ENABLE_CONTRACT_BACKDATE_ENTRY = "SUBCONTRACTOR_MODULE.ENABLE_CONTRACT_BACKDATE_ENTRY";
export const VIEW_SUBCONTRACTOR_STATEMENT = "SUBCONTRACTOR_MODULE.VIEW_SUBCONTRACTOR_STATEMENT";
export const CREATE_SUBCONTRACTOR_TRANSACTION = "SUBCONTRACTOR_MODULE.CREATE_SUBCONTRACTOR_TRANSACTION";
export const EDIT_SUBCONTRACTOR_TRANSACTION = "SUBCONTRACTOR_MODULE.EDIT_SUBCONTRACTOR_TRANSACTION";
export const DELETE_SUBCONTRACTOR_TRANSACTION = "SUBCONTRACTOR_MODULE.DELETE_SUBCONTRACTOR_TRANSACTION";
export const EXPORT_SUBCONTRACTOR_TRANSACTION = "SUBCONTRACTOR_MODULE.EXPORT_SUBCONTRACTOR_TRANSACTION";
export const ENABLE_SUBCONTRACTOR_TRANSACTION_BACKDATE_ENTRY =
  "SUBCONTRACTOR_MODULE.ENABLE_SUBCONTRACTOR_TRANSACTION_BACKDATE_ENTRY";
export const VIEW_SUBCONTRACTOR_ANALYTICS = "SUBCONTRACTOR_MODULE.VIEW_SUBCONTRACTOR_ANALYTICS";
export const ENABLE_SUBCONTRACTOR_ADVANCE_PAYMENT = "SUBCONTRACTOR_MODULE.ENABLE_SUBCONTRACTOR_ADVANCE_PAYMENT";
export const VIEW_SUBCONTRACTOR_LEDGER_MODE_STATEMENT = "SUBCONTRACTOR_MODULE.VIEW_SUBCONTRACTOR_LEDGER_MODE_STATEMENT";

// Vendor Module and Features
export const VENDOR_MODULE = "VENDOR_MODULE";
export const VIEW_VENDOR = "VENDOR_MODULE.VIEW_VENDOR";
export const CREATE_VENDOR = "VENDOR_MODULE.CREATE_VENDOR";
export const EDIT_VENDOR = "VENDOR_MODULE.EDIT_VENDOR";
export const DELETE_VENDOR = "VENDOR_MODULE.DELETE_VENDOR";
export const EXPORT_VENDOR = "VENDOR_MODULE.EXPORT_VENDOR";
export const CREATE_PURCHASE = "VENDOR_MODULE.CREATE_PURCHASE";
export const EDIT_PURCHASE = "VENDOR_MODULE.EDIT_PURCHASE";
export const RETURN_PURCHASE = "VENDOR_MODULE.RETURN_PURCHASE";
export const DELETE_PURCHASE = "VENDOR_MODULE.DELETE_PURCHASE";
export const EDIT_PURCHASE_RETURN = "VENDOR_MODULE.EDIT_PURCHASE_RETURN";
export const DELETE_PURCHASE_RETURN = "VENDOR_MODULE.DELETE_PURCHASE_RETURN";
export const EXPORT_PURCHASE = "VENDOR_MODULE.EXPORT_PURCHASE";
export const ENABLE_PURCHASE_BACKDATE_ENTRY = "VENDOR_MODULE.ENABLE_PURCHASE_BACKDATE_ENTRY";
export const ADD_VENDOR_PAYMENT = "VENDOR_MODULE.ADD_VENDOR_PAYMENT";
export const EDIT_VENDOR_PAYMENT = "VENDOR_MODULE.EDIT_VENDOR_PAYMENT";
export const DELETE_VENDOR_PAYMENT = "VENDOR_MODULE.DELETE_VENDOR_PAYMENT";
export const ENABLE_VENDOR_PAYMENT_BACKDATE_ENTRY = "VENDOR_MODULE.ENABLE_VENDOR_PAYMENT_BACKDATE_ENTRY";
export const VIEW_VENDOR_ANALYTICS = "VENDOR_MODULE.VIEW_VENDOR_ANALYTICS";
export const VIEW_VENDOR_STATEMENT = "VENDOR_MODULE.VIEW_VENDOR_STATEMENT";
export const VIEW_VENDOR_LEDGER_MODE_STATEMENT = "VENDOR_MODULE.VIEW_VENDOR_LEDGER_MODE_STATEMENT";
export const EXPORT_VENDOR_STATEMENT = "VENDOR_MODULE.EXPORT_VENDOR_STATEMENT";
export const VIEW_MATERIAL = "VENDOR_MODULE.VIEW_MATERIAL";
export const CREATE_MATERIAL = "VENDOR_MODULE.CREATE_MATERIAL";
export const EDIT_MATERIAL = "VENDOR_MODULE.EDIT_MATERIAL";
export const DELETE_MATERIAL = "VENDOR_MODULE.DELETE_MATERIAL";
export const ENABLE_VENDOR_ADVANCE_PAYMENT = "VENDOR_MODULE.ENABLE_VENDOR_ADVANCE_PAYMENT";

// User Module and Features
export const USER_MODULE = "USER_MODULE";
export const VIEW_USER = "USER_MODULE.VIEW_USER";
export const CREATE_USER = "USER_MODULE.CREATE_USER";
export const EDIT_USER = "USER_MODULE.EDIT_USER";
export const DELETE_USER = "USER_MODULE.DELETE_USER";
export const EXPORT_USER = "USER_MODULE.EXPORT_USER";
export const VIEW_USER_STATEMENT = "USER_MODULE.VIEW_USER_STATEMENT";
export const ADD_USER_PAYMENT = "USER_MODULE.ADD_USER_PAYMENT";
export const EDIT_USER_PAYMENT = "USER_MODULE.EDIT_USER_PAYMENT";
export const DELETE_USER_PAYMENT = "USER_MODULE.DELETE_USER_PAYMENT";
export const EXPORT_USER_STATEMENT = "USER_MODULE.EXPORT_USER_STATEMENT";
export const RESET_USER_PASSWORD = "USER_MODULE.RESET_USER_PASSWORD";
export const VIEW_ROLE = "USER_MODULE.VIEW_ROLE";
export const CREATE_ROLE = "USER_MODULE.CREATE_ROLE";
export const EDIT_ROLE = "USER_MODULE.EDIT_ROLE";
export const DELETE_ROLE = "USER_MODULE.DELETE_ROLE";
export const ENABLE_USER_PAYMENT_BACKDATE_ENTRY = "USER_MODULE.ENABLE_USER_PAYMENT_BACKDATE_ENTRY";

// Finance Module and Features
export const FINANCE_MODULE = "FINANCE_MODULE";
export const VIEW_FINANCE_CATEGORY = "FINANCE_MODULE.VIEW_FINANCE_CATEGORY"; // TODO: TBD
export const CREATE_FINANCE_CATEGORY = "FINANCE_MODULE.CREATE_FINANCE_CATEGORY";
export const EDIT_FINANCE_CATEGORY = "FINANCE_MODULE.EDIT_FINANCE_CATEGORY";
export const DELETE_FINANCE_CATEGORY = "FINANCE_MODULE.DELETE_FINANCE_CATEGORY";
// export const FINANCE_CATEGORY_EXPORT = "FINANCE_MODULE.CATEGORY_EXPORT"; // TODO: TBD
export const VIEW_EXPENSE = "FINANCE_MODULE.VIEW_EXPENSE";
export const CREATE_EXPENSE = "FINANCE_MODULE.CREATE_EXPENSE";
export const EDIT_EXPENSE = "FINANCE_MODULE.EDIT_EXPENSE";
export const DELETE_EXPENSE = "FINANCE_MODULE.DELETE_EXPENSE";
export const ENABLE_EXPENSE_BACKDATE_ENTRY = "FINANCE_MODULE.ENABLE_EXPENSE_BACKDATE_ENTRY";
export const VIEW_INCOME = "FINANCE_MODULE.VIEW_INCOME";
export const CREATE_INCOME = "FINANCE_MODULE.CREATE_INCOME";
export const EDIT_INCOME = "FINANCE_MODULE.EDIT_INCOME";
export const DELETE_INCOME = "FINANCE_MODULE.DELETE_INCOME";

// Account Module and Features
export const ACCOUNT_MODULE = "ACCOUNT_MODULE";
export const VIEW_ACCOUNT = "ACCOUNT_MODULE.VIEW_ACCOUNT";
export const CREATE_ACCOUNT = "ACCOUNT_MODULE.CREATE_ACCOUNT";
export const EDIT_ACCOUNT = "ACCOUNT_MODULE.EDIT_ACCOUNT";
export const DELETE_ACCOUNT = "ACCOUNT_MODULE.DELETE_ACCOUNT";
export const ADD_ACCOUNT_TRANSACTION = "ACCOUNT_MODULE.ADD_ACCOUNT_TRANSACTION";
export const EDIT_ACCOUNT_TRANSACTION = "ACCOUNT_MODULE.EDIT_ACCOUNT_TRANSACTION";
export const DELETE_ACCOUNT_TRANSACTION = "ACCOUNT_MODULE.DELETE_ACCOUNT_TRANSACTION";
export const EXPORT_ACCOUNT_TRANSACTION = "ACCOUNT_MODULE.EXPORT_ACCOUNT_TRANSACTION";
export const ENABLE_ACCOUNT_PAYMENT_BACKDATE_ENTRY = "ACCOUNT_MODULE.ENABLE_ACCOUNT_PAYMENT_BACKDATE_ENTRY";
export const VIEW_ACCOUNT_LEDGER_MODE_STATEMENT = "ACCOUNT_MODULE.VIEW_ACCOUNT_LEDGER_MODE_STATEMENT";

// Task Module and Features
export const TASK_MODULE = "TASK_MODULE";
export const VIEW_ALL_TASK = "TASK_MODULE.VIEW_ALL_TASK";
export const VIEW_ASSIGNED_TASK = "TASK_MODULE.VIEW_ASSIGNED_TASK";
export const CREATE_TASK = "TASK_MODULE.CREATE_TASK";
export const EDIT_TASK = "TASK_MODULE.EDIT_TASK";
export const DELETE_TASK = "TASK_MODULE.DELETE_TASK";
export const EXPORT_TASK = "TASK_MODULE.EXPORT_TASK";
export const VIEW_TASK_PROGRESS = "TASK_MODULE.VIEW_TASK_PROGRESS";
export const CREATE_TASK_PROGRESS = "TASK_MODULE.CREATE_TASK_PROGRESS";
export const EDIT_TASK_PROGRESS = "TASK_MODULE.EDIT_TASK_PROGRESS";
export const DELETE_TASK_PROGRESS = "TASK_MODULE.DELETE_TASK_PROGRESS";

// Tool Module and Features
export const TOOL_MODULE = "TOOL_MODULE";
export const VIEW_TOOL = "TOOL_MODULE.VIEW_TOOL";
export const CREATE_TOOL = "TOOL_MODULE.CREATE_TOOL";
export const EDIT_TOOL = "TOOL_MODULE.EDIT_TOOL";
export const DELETE_TOOL = "TOOL_MODULE.DELETE_TOOL";
export const EXPORT_TOOL = "TOOL_MODULE.EXPORT_TOOL";
export const MOVE_TOOL = "TOOL_MODULE.MOVE_TOOL";
export const UPDATE_STOCK = "TOOL_MODULE.UPDATE_STOCK";

// Performance Guarantee Module and Features
export const PERFORMANCE_GUARANTEE_MODULE = "PG_MODULE";
export const VIEW_PERFORMANCE_GUARANTEE = "PG_MODULE.VIEW_PG";
export const CREATE_PERFORMANCE_GUARANTEE = "PG_MODULE.CREATE_PG";
export const EDIT_PERFORMANCE_GUARANTEE = "PG_MODULE.EDIT_PG";
export const DELETE_PERFORMANCE_GUARANTEE = "PG_MODULE.DELETE_PG";
export const RELEASE_PERFORMANCE_GUARANTEE = "PG_MODULE.RELEASE_PG";
export const EXPORT_PERFORMANCE_GUARANTEE = "PG_MODULE.EXPORT_PG";

// Invoice Module and Features
export const INVOICE_MODULE = "INVOICE_MODULE";
export const VIEW_GOVERNMENT_INVOICE = "INVOICE_MODULE.VIEW_GOVERNMENT_CLIENT_INVOICE";
export const CREATE_GOVERNMENT_INVOICE = "INVOICE_MODULE.CREATE_GOVERNMENT_CLIENT_INVOICE";
export const EDIT_GOVERNMENT_INVOICE = "INVOICE_MODULE.EDIT_GOVERNMENT_CLIENT_INVOICE";
export const DELETE_GOVERNMENT_INVOICE = "INVOICE_MODULE.DELETE_GOVERNMENT_CLIENT_INVOICE";
export const VIEW_CUSTOM_INVOICE = "INVOICE_MODULE.VIEW_CUSTOM_CLIENT_INVOICE";
export const CREATE_CUSTOM_INVOICE = "INVOICE_MODULE.CREATE_CUSTOM_CLIENT_INVOICE";
export const EDIT_CUSTOM_INVOICE = "INVOICE_MODULE.EDIT_CUSTOM_CLIENT_INVOICE";
export const DELETE_CUSTOM_INVOICE = "INVOICE_MODULE.DELETE_CUSTOM_CLIENT_INVOICE";

// Mobile Analytics Module and Features
export const MOBILE_ANALYTICS_MODULE = "MOBILE_ANALYTICS_MODULE";
export const VIEW_BUDGET_OVERVIEW = "MOBILE_ANALYTICS_MODULE.BUDGET_OVERVIEW";
export const VIEW_PROJECT_OVERVIEW = "MOBILE_ANALYTICS_MODULE.PROJECT_OVERVIEW";

// CRM Pro Module and Features
export const CRM_PRO_MODULE = "CRM_PRO_MODULE";
export const CRM_PRO_VIEW_ALL_LEAD = "CRM_PRO_MODULE.VIEW_ALL_LEAD";
export const CRM_PRO_VIEW_ASSIGNED_LEAD = "CRM_PRO_MODULE.VIEW_ASSIGNED_LEAD";
export const CRM_PRO_CREATE_LEAD = "CRM_PRO_MODULE.CREATE_LEAD";
export const CRM_PRO_EDIT_LEAD = "CRM_PRO_MODULE.EDIT_LEAD";
export const CRM_PRO_DELETE_LEAD = "CRM_PRO_MODULE.DELETE_LEAD";
export const CRM_PRO_EXPORT_LEAD = "CRM_PRO_MODULE.EXPORT_LEAD";
export const CRM_PRO_CREATE_LEAD_STATUS = "CRM_PRO_MODULE.CREATE_LEAD_STATUS";
export const CRM_PRO_EDIT_LEAD_STATUS = "CRM_PRO_MODULE.EDIT_LEAD_STATUS";
export const CRM_PRO_DELETE_LEAD_STATUS = "CRM_PRO_MODULE.DELETE_LEAD_STATUS";
export const CRM_PRO_CREATE_TASK = "CRM_PRO_MODULE.CREATE_TASK";
export const CRM_PRO_EDIT_TASK = "CRM_PRO_MODULE.EDIT_TASK";
export const CRM_PRO_DELETE_TASK = "CRM_PRO_MODULE.DELETE_TASK";
export const CRM_PRO_UPDATE_TASK_PROGRESS = "CRM_PRO_MODULE.UPDATE_TASK_PROGRESS";
export const CRM_PRO_UPLOAD_DOCUMENT = "CRM_PRO_MODULE.UPLOAD_DOCUMENT";
export const CRM_PRO_DELETE_DOCUMENT = "CRM_PRO_MODULE.DELETE_DOCUMENT";

// Report Module and Features
export const REPORT_MODULE = "REPORT_MODULE";
export const GENERATE_CRM_REPORT = "REPORT_MODULE.GENERATE_CRM_REPORT";
export const GENERATE_PROJECT_REPORT = "REPORT_MODULE.GENERATE_PROJECT_REPORT";
export const GENERATE_CLIENT_REPORT = "REPORT_MODULE.GENERATE_CLIENT_REPORT";
export const GENERATE_EMPLOYEE_REPORT = "REPORT_MODULE.GENERATE_EMPLOYEE_REPORT";
export const GENERATE_WORKER_REPORT = "REPORT_MODULE.GENERATE_WORKER_REPORT";
export const GENERATE_SUBCONTRACTOR_REPORT = "REPORT_MODULE.GENERATE_SUBCONTRACTOR_REPORT";
export const GENERATE_VENDOR_REPORT = "REPORT_MODULE.GENERATE_VENDOR_REPORT";
export const GENERATE_PURCHASE_REPORT = "REPORT_MODULE.GENERATE_PURCHASE_REPORT";
export const GENERATE_MATERIAL_REPORT = "REPORT_MODULE.GENERATE_MATERIAL_REPORT";
export const GENERATE_USER_REPORT = "REPORT_MODULE.GENERATE_USER_REPORT";
export const GENERATE_EXPENSE_REPORT = "REPORT_MODULE.GENERATE_EXPENSE_REPORT";
export const GENERATE_ACCOUNT_REPORT = "REPORT_MODULE.GENERATE_ACCOUNT_REPORT";
export const GENERATE_DAILY_REPORT = "REPORT_MODULE.GENERATE_DAILY_REPORT";
export const GENERATE_TOOL_REPORT = "REPORT_MODULE.GENERATE_TOOL_REPORT";

// Office Module and Features
export const OFFICE_MODULE = "OFFICE_MODULE";
export const VIEW_OFFICE_DASHBOARD = "OFFICE_MODULE.VIEW_OFFICE_DASHBOARD";
export const VIEW_OFFICE_BUDGET_OVERVIEW = "OFFICE_MODULE.VIEW_OFFICE_BUDGET_OVERVIEW";
export const VIEW_OFFICE_DOCUMENTS = "OFFICE_MODULE.VIEW_OFFICE_DOCUMENTS";
export const EXPORT_OFFICE_REPORT = "OFFICE_MODULE.EXPORT_OFFICE_REPORT";
export const SELECT_OFFICE_ACCOUNT_IN_ENTRIES = "OFFICE_MODULE.SELECT_OFFICE_ACCOUNT_IN_ENTRIES";
